import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { engagement } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Mail, Loader2, CheckCircle2, XCircle, ArrowRight } from 'lucide-react';

/** Route: /review-invite/:token — customer clicks the emailed link from a
 *  business owner. We redeem it once and issue a review permission. */
export default function ReviewInvite() {
  const { token } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState('working'); // working | ok | err
  const [err, setErr] = useState('');
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (!user) { navigate(`/login?redirect=/review-invite/${token}`); return; }
    engagement.redeemInvite(token).then(res => { setResult(res); setState('ok'); })
      .catch(e => { setErr(e?.response?.data?.detail || 'Invite could not be redeemed.'); setState('err'); });
  }, [token, user, navigate]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center py-8">
      <div className="pbb-card p-6 w-full max-w-md space-y-4" data-testid="review-invite">
        <div className="flex items-center gap-2">
          <Mail className="text-green-400" size={22}/>
          <div>
            <div className="font-semibold">Review invitation</div>
            <div className="text-xs text-gray-400">A business owner asked you to share your honest experience.</div>
          </div>
        </div>
        {state === 'working' && (
          <div className="rounded-lg bg-[#0d1f14] border border-[#153b23] p-4 text-sm inline-flex items-center gap-2">
            <Loader2 className="animate-spin text-green-400" size={16}/> Redeeming your invite…
          </div>
        )}
        {state === 'err' && (
          <div className="rounded-lg bg-red-600/10 border border-red-600/40 p-3 text-sm text-red-300 inline-flex items-center gap-2" data-testid="invite-err">
            <XCircle size={16}/> {err}
          </div>
        )}
        {state === 'ok' && result && (
          <div className="space-y-3" data-testid="invite-ok">
            <div className="rounded-lg bg-green-600/10 border border-green-600/40 p-3 text-sm text-green-300 inline-flex items-center gap-2">
              <CheckCircle2 size={16}/> Invite confirmed for {result.businessName}. You can leave one review.
            </div>
            <Link to={`/business/${result.businessId}`} className="pbb-btn-green w-full inline-flex items-center justify-center gap-2">
              Leave your review <ArrowRight size={14}/>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
